import { useEffect } from 'react';

import { PAGE_JOB_UPGRADE_BUTTON_VIEWED } from 'src/App/constants/tracking.ts';
import type { JobListItemFragment } from 'src/graphql/__generated__';
import { useQueryParam } from 'src/hooks/useQueryParam';
import { useTracking } from 'src/hooks/useTracking';

interface Props {
  jobs: JobListItemFragment[];
}

export const TabLoadTracker = ({ jobs }: Props) => {
  const { trackingData, trackEvent } = useTracking();
  const { userId } = trackingData;
  const { page, tab } = useQueryParam();

  useEffect(() => {
    const hasJobUpgradeButton = jobs.some((job) => job.canBeUpgraded);
    if (userId && tab === 'open') {
      trackEvent(PAGE_JOB_UPGRADE_BUTTON_VIEWED, {
        hasJobUpgradeButton,
        pageNumber: page,
      });
    }
  }, [page, tab, userId, trackEvent, jobs]);

  return null;
};
